import { apiClient } from "../clients/api.client.ts";
import ReactDOM from 'react-dom';
import { ProductDto, ProductVariantDto } from "@pa/common";

export class MyItemsTheme {
  private childProductContainerEle: HTMLDivElement;
  public customerSavedProductVariants: ProductVariantDto[];
  public customerSavedProducts: ProductDto[];
  private allTilesPage: string;
  private savedIdsMixed: string[];


  constructor() {
    this.childProductContainerEle = this.getChildProductContainerEle();
    this.customerSavedProductVariants = [];
    this.customerSavedProducts = [];
    this.savedIdsMixed = [];
    this.allTilesPage = "/collections/all-items";
  }

  getChildProductContainerEle = () => {
    if (this.childProductContainerEle) {
      return this.childProductContainerEle;
    }
    const foundEle = document.querySelector<HTMLDivElement>(
      ".my-items--child-products"
    );
    if (!foundEle) {
      throw new Error("Unable to getChildProductContainerEle");
    }
    this.childProductContainerEle = foundEle;
    return this.childProductContainerEle;
  };

  loadVariants = async () => {
    try {
      const loadedData = await apiClient.variants.getSaved();
      this.customerSavedProductVariants = loadedData;

      const variantIds = loadedData.map((variant) => String(variant.shopify_variant_id));
      this.savedIdsMixed = [...this.savedIdsMixed, ...variantIds];
    } catch (e) {  
      //no customer
    }
  };

  loadProducts = async () => {
    try {
      const loadedData = await apiClient.products.getSaved();
      this.customerSavedProducts = loadedData;

      const productIds = loadedData.map((product) => String(product.shopify_product_id));
      this.savedIdsMixed = [...this.savedIdsMixed, ...productIds];      
    } catch (e) {       
      //no customer
    }
  };

  renderFavourites = (ids: string[]) => {
    if(!(window as any).pageItems) return;
    let newCards = "";
    ids.forEach((id) => {
      if(!(window as any).pageItems[id]) return true;
      const tile = (window as any).pageItems[id].card_html.replace('animate--slide-in', '');      
      newCards += tile;      
    });
    (window as any).refreshMyItems = true;
    this.childProductContainerEle.innerHTML = newCards;
  };
  
  mount = async () => {
    const childProductContainer = this.getChildProductContainerEle();
    childProductContainer?.classList.add("loading");
    await this.loadVariants();
    await this.loadProducts();
    this.renderFavourites(this.savedIdsMixed);
    childProductContainer.classList.remove("loading");
  }
}